module.exports = __webpack_public_path__ + "img/slide_two.895abca2.jpg";